import { CardSvg } from '@/play/cardSvg'

/** Home card art for Apple tree: a tree with apples, one big one falling. */
export function AppleTreeCardArt() {
  return (
    <CardSvg bg="#e8f2f8">
      <path d="M0 170 H 320 V 200 H 0 Z" fill="#9cc46a" />
      <rect x="148" y="96" width="22" height="76" fill="#6e4628" />
      <path d="M158 110 L 110 80 M 160 104 L 214 76" stroke="#9a6a40" strokeWidth="9" strokeLinecap="round" />
      <ellipse cx="104" cy="70" rx="44" ry="30" fill="#4f9a3a" />
      <ellipse cx="216" cy="66" rx="46" ry="30" fill="#4f9a3a" />
      <ellipse cx="160" cy="46" rx="40" ry="28" fill="#5aa845" />
      <rect x="92" y="98" width="12" height="12" rx="3" fill="#e0302a" />
      <rect x="222" y="94" width="12" height="12" rx="3" fill="#e0302a" />
      <rect x="236" y="128" width="26" height="26" rx="6" fill="#e0302a" />
      <path d="M249 104 V 118" stroke="#1d2b36" strokeWidth="3" strokeDasharray="3 4" strokeLinecap="round" />
      <path d="M40 170 C 50 150, 74 150, 84 170 Z" fill="#e2c48a" />
    </CardSvg>
  )
}
